const CNAPS_TEST = `cnaps-student/v1/`;

export const endpoints = {
  SUBMIT_HALL_TICKET: `${CNAPS_TEST}usage/certificate-details`,
  ALERT_MESSAGES: "cnaps-admin/v1/admin/alert-msgs"
};
